import { inputStyle } from "../../css/dinamic/modal";
import { emptys } from "../../data/main";

export default function ScheduleInfo({ info }) {
  return (
    !emptys.includes(info) && (
      <div
        style={inputStyle({
          height: "auto",
          textWrap: "break-word",
          maxHeight: 400,
          overflow: "auto",
        })}
      >
        {info !== "" &&
          info.split(/([,;| \n])/).map((e, index) =>
            e.toLowerCase().startsWith("https://") ? (
              <a key={index} href={e} target={"_blank"} rel={"noreferrer"}>
                {e}
              </a>
            ) : e === "\n" ? (
              <div key={index} />
            ) : (
              <span key={index}>{e}</span>
            )
          )}
      </div>
    )
  );
}
